function beautifyJson(data) {
    let result = JSON.stringify(data)
                     .replace(/}/gi, '')
                     .replace(/{/gi, '')
                     .replace(/"/gi, '')
                     .replace(/,/gi, ', ')
                     .replace(/:/gi, ': ')
                     .trim();

    if (result === '') {
        if (Array.isArray(data)) {
            return '[]';
        }
        return '{}';
    }

    return result;
}

export default beautifyJson;
